import { HashRouter } from "react-router-dom";
import PageList from "./pages/PageList";

function App() {
    return (
        <>
            <HashRouter>
                <PageList />
            </HashRouter>
        </>
    );
}

export default App;
